import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "arraySort"
})
export class ArraySortPipe  implements PipeTransform {

  transform(array: any, field: string, isDesc: boolean = false): any[] {
    if (!Array.isArray(array)) {
      return;
    }
    array.sort((a: any, b: any) => {
      const fieldA = a[field] ?? null;
      const fieldB = b[field] ?? null;

      if (fieldA === null) { return 1;}
      if (fieldB === null) { return -1;}

      if (fieldA < fieldB) {
        return isDesc ? 1: -1;
      } else if (fieldA > fieldB) {
        return isDesc ? -1 : 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}
